var map = {
	"./01_error_code.json": "+lFy",
	"./02_timestamp.json": "VQr5",
	"./03_digital_rule.json": "C2jk",
	"./04_rate_limits.json": "nG30",
	"./05_system_time.json": "zNUa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g+/I";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/api/basic \.json$
// module id = g+/I
// module chunks = 3